// extracted by mini-css-extract-plugin
module.exports = {"pending-premium":"styles-m__pending-premium__1L884","premium-count":"styles-m__premium-count__3VPAg"};